import { useMemo } from 'react';

import { formatters } from '@Components/hierarchical-report/utils'

import { useContestsSubscriptionsState } from '../hooks/states';

import DefaultFormatter from './DefaultFormatter';

export default function useColumns() {
  const { selectedFields } = useContestsSubscriptionsState()

  return useMemo(() => selectedFields.map(value => ({
    dataField: value,
    text: formatters.groupsText(value),
    formatter: DefaultFormatter,
  })), [selectedFields])
}
